var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"72c996b82d7ec35f4f718cb7bde561c5e9f0eadc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["keune@ask-phill"]={id:"72c996b82d7ec35f4f718cb7bde561c5e9f0eadc"};
      